import React from 'react';
import './index.scss';
import { betaTestPrivacyPolicyData } from './betaTestPrivacyPolicyData';
import useHashScroll from './hooks/useHashScroll';

function BetaTestPrivacyPolicy() {
  useHashScroll();

  return (
    <div className="term-container">
      {betaTestPrivacyPolicyData.map((block, index) => {
        const { type, content, items, className } = block;
        const key = `${type}-${index}`;

        switch (type) {
          case 'h1':
            return <h1 key={key}>{content}</h1>;
          case 'h2':
            return <h2 key={key}>{content}</h2>;
          case 'p':
            return <p key={key} className={className} dangerouslySetInnerHTML={{ __html: content }} />;
          case 'list':
            return (
              <ul key={key}>
                {items.map((item, itemIndex) => (
                  <li key={`${key}-item-${itemIndex}`}>
                    {item.title && <strong>{`${item.title} `}</strong>}
                    <span dangerouslySetInnerHTML={{ __html: item.text }} />
                  </li>
                ))}
              </ul>
            );
          default:
            return null;
        }
      })}
    </div>
  );
}

export default BetaTestPrivacyPolicy;
